// shared responsive product grid — single source of truth for grid layout
export default function ProductGrid({ children }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 gap-[15px] md:gap-[30px]">
      {children}
    </div>
  );
}
